<template>
  <div class="flex flex-col w-full px-5 md:px-15 py-12.5 bg-primary-dark text-light">
    <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-9 border-b border-text-accent-light pb-10">
      <div v-for="(section, ids) in siteSettings.footerLinks[config.public.layoutDesign] || []" :key="`section_${ids}`" class="flex flex-col">
        <div class="uppercase font-bold mb-6">
          {{ $t(section.label) }}
        </div>
        <div v-for="(link, idx) in section.links" :key="`link_${idx}`" class="flex flex-col mb-3">
          <div v-if="link?.type === 'socialIcons'" class="flex items-center justify-start space-x-5 pt-0.5">
            <a
              v-for="(item, index) in siteSettings.author[config.public.layoutDesign].social || []"
              :key="index"
              :href="item.link"
              target="_blank"
              class="no-underline text-light transition-colors duration-200 focus:outline-none hover:text-selected-menu-hover focus:text-selected-menu-hover hover:underline focus:underline"
              :aria-label="$t(item.label)"
            >
              <SocialIcon :icon="item.icon" class="w-6 h-6" />
            </a>
          </div>
          <a
            v-else-if="link.sidebar || link.external"
            :href="link.external ? link.href : translatePath(link.routeCode)"
            class="no-underline text-link-accent transition-colors duration-200 focus:outline-none hover:text-light focus:text-light hover:underline focus:underline"
            :aria-label="link.title ? link.title : $t(link.label)"
            @click.prevent="async () => await handleClick(link)"
          >
            {{ link.title ? link.title : $t(link.label) }}
          </a>
          <Link
            v-else-if="config?.public?.feature?.mobileApp || link.routeCode !== ROUTES.CODE.APP"
            :href="link.external ? link.href : translatePath(link.routeCode)"
            class="no-underline text-link-accent transition-colors duration-200 focus:outline-none hover:text-light focus:text-light hover:underline focus:underline"
            :active-class="route.path === translatePath(link.routeCode) ? 'text-light' : ''"
            :aria-label="link.title ? link.title : $t(link.label)"
          >
            {{ link.title ? link.title : $t(link.label) }}
          </Link>
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between mt-6">
      <Link
        :href="translatePath(ROUTES.CODE.HOME)"
        class="flex-shrink-0 inline-flex"
        :aria-label="$t(siteSettings.author[config.public.layoutDesign].label)"
      >
        <img
          :src="`/logo/${config.public.layoutDesign}-color.svg`"
          :alt="$t(siteSettings.author[config.public.layoutDesign].label)"
          :width="siteSettings.logo[config.public.layoutDesign]?.footer?.width || 63"
          :height="siteSettings.logo[config.public.layoutDesign]?.footer?.width || 30"
          :class="siteSettings.logo[config.public.layoutDesign]?.footer?.class || ''"
          loading="lazy"
        >
      </Link>
      <div class="flex flex-col sm:flex-row items-end justify-end">
        <LanguageSwitcher />
        <div class="text-base ml-10">
          © {{ $dayjs().locale(routeLang.code.value).format('YYYY') }} {{ $t(siteSettings.author[config.public.layoutDesign].label) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { siteSettings } from "@settings/site.settings";
import Link from "@components/ui/link/link";
import LanguageSwitcher from "@components/common/language-switcher";
import SocialIcon from "@components/ui/icon/social-icon";

const { $eventBus, $dayjs } = useNuxtApp();
const config = useRuntimeConfig();
const route = useRoute();
const routeLang = useRouteLang();

const handleClick = async (link) => {
  if (link.external) {
    await navigatorTo(link.href, { external: true });
  } else if (link.sidebar) {
    $eventBus.emit('sidebar:open', link.sidebar);
  } else {
    await navigatorTo(translatePath(link.routeCode));
  }
}

</script>
